import triyoAPI from "./triyo";
import { getToken } from "./api-util.js";

const config = () => {
  let token = getToken();
  return {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const fetchEndpointData = async (fetchMethod, setData) => {
  try {
    const res = await fetchMethod();
    if (res?.status === 200 && res.data !== null) {
      setData(res.data);
    }
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const GetTechnologyExport = (type) => {
  return triyoAPI.get("/data/technology/excel?type=" + type, config());
};

export const getDashboardData = async (endpoint) => {
  try {
    const response = await triyoAPI.get(`/dashboard/${endpoint}`, config());
    if (response.data.status === "dashboardNotAuthorized") {
      console.log(response.data.message);
      return null;
    } else {
      console.log(`Dashboard [${endpoint}]:`);
      console.log(response.data);
      return response;
    }
  } catch (error) {
    console.log(`Error rendering [/dashboard/${endpoint}]:`);
    console.log(error,error?.response);
    return null;
  }
};

export const getExportData = async (endpoint) => {
  try {
    const response = await triyoAPI.get(endpoint, config());
    if (response?.status === 200) {
      const link = document.createElement("a");
      link.href = response.data;
      link.download = "filename";
      link.click();
    } else {
      console.log(response);
      return null;
    }
  } catch (error) {
    console.log(`Error exporting [${endpoint}]:`);
    console.log(error);
    return null;
  }
};

export const GetEmailData = () => getDashboardData("email");

export const GetConsumerRetailProjectTimeLog = () => getDashboardData("ConsumerRetail/ProjectTimeLog");
export const GetConsumerRetailMemberTimeLog = () => getDashboardData("ConsumerRetail/MemberTimeLog");

export const GetGPCProjectTimeLog = () => getDashboardData("gpc/projecttimelog");
export const GetGPCProjectTimeLogExcelExport = () => getExportData("/data/gpcProject/excel");

export const GetGPCMemberTimeLog = () => getDashboardData("gpc/membertimelog");
export const GetGPCMemberTimeLogExcelExport = () => getExportData("/data/gpcMember/excel");

export const GetHealthcareData = () => getDashboardData("healthcare");
export const GetHealthcareExcelExport = () => getExportData("/data/healthcare/excel");

export const GetFIGData = (type) => getDashboardData("fig?type=" + type);
export const GetFigExcelExport = (type) => getExportData("/data/fig/excel?type=" + type);

export const GetSponsorshipDonationsData = () => getDashboardData("sponsorshipdonations");
export const GetSponsorshipExcelExport = () => getExportData("/data/sponsorship/excel");

// export const GetLevFinData = (type) => getDashboardData("levfin?type=" + type);
export const GetLevFinExcelExport = (type) => getExportData("/data/levfin/excel?type=" + type);
export const GetLevFinGroupHeadDealLog = () => getDashboardData("LevFinGroupHeadDealLog");
export const GetLevFinGroupHeadDealTrackerExcelExport = () => getExportData("/data/levfinGroupHeadDealTracker/excel");
export const GetLevFinGroupHeadDealLogExcelExport = () => getExportData("/data/levfinGroupHeadDeal/excel");

export const GetMergersAndAcquisitionsData = (type) => getDashboardData("mergersAndAcquisitions?type=" + type);
export const GetMergersAndAcquisitionsExcelExport = (type) => getExportData("/data/mergersAndAcquisitions/excel?type=" + type);
export const UpdateMergersLastUpdated = (taskId)  => {
  return triyoAPI.put(`/dashboard/mergersAndAcquisitions/updateMergersLastUpdated?taskId=` + taskId,null, config());
};

export const GetCMEMemberTimeLog= () => getDashboardData("cme/membertimelog");
export const GetCMEProjectTimeLog= () => getDashboardData("cme/projecttimelog");
export const GetCMEGroupHeadProjectTimeLog= () => getDashboardData("cme/groupheadprojecttimelog");
export const GetCMEGroupHeadDealLog = () => getDashboardData("cme/groupheaddealtracker");
export const GetCMEMemberTimeLogExcelExport= () => getExportData("data/cmeMember/excel");
export const GetCMEProjectTimeLogExcelExport = () => getExportData("data/cmeProject/excel");
export const GetCMEGroupHeadDealLogExcelExport = () => getExportData("data/cmeGroupHeadDeal/excel");
export const GetCMEGroupHeadProjectTimeLogExcelExport = () => getExportData("data/cmeGroupHeadProject/excel");

export const GetRealEstateData = (type) => getDashboardData("realEstate?type=" + type);
export const GetRealEstateDealTrackerExcelExport = (type) => getExportData("/data/realestatedealtracker/excel?type=" + type);
export const GetRealEstateWorklogExcelExport = (type) => getExportData("/data/realestateworklog/excel?type=" + type);
export const GetREProjectLogExcelExport = () => getExportData("/data/REProjectLog/excel");

export const GetTechStafferHistoricalData = async (filterDto) => {
  return await triyoAPI.post("tech/stafferhistoricaldata", filterDto, config());
};
export const GetTechStafferHistoricalExcelExport = async (filterDto) => {
  return await triyoAPI.post("data/techStafferHistoricalData/excel", filterDto, config());
};
export const GetTechStafferRawExcelExport = async (filterDto) => {
  return await triyoAPI.post("data/GetTechStafferRawExcelExport/excel", filterDto, config());
};
export const GetTechGroupHeadDealTracker = () => getDashboardData("tech/groupheaddealtracker");
export const GetTechGroupHeadDealLog = () => getDashboardData("tech/groupheaddeallog");
export const GetTechGHDealLogExcelExport = () => getExportData("data/techGHDeal/excel");
export const GetTechGHDealTrackerExcelExport = () => getExportData("data/techGHDealTracker/excel");

export const GetDashboardCompaniesAPI = () => {
  return triyoAPI.get(`/dashboard/GetDashboardCompanies`, config())
}

export const fetchbigNumbersWidgetData = () => {
  return getDashboardData("str/bigNumbers");
}

export const fetchActiveSTRData = () => {
  return getDashboardData("str/activeTasks");
}

export const fetchSTRLineGraphData = (startDate, endDate) => {
  return getDashboardData(`str/STRlineGraph?startDate=${startDate}&endDate=${endDate}`);
};

export const fetchWorkLoadData = () => {
  return getDashboardData("str/workload");
}

export const fetchSTRNoFilingVsCompleteLineGraphData = (startDate, endDate, ownerId) => {
  return getDashboardData(`str/NoFilingVsCompleteLineGraph?startDate=${startDate}&endDate=${endDate}&ownerId=${ownerId}`);
};

export const fetchCompletedSTRData = (startDate, endDate) => {
  return getDashboardData(`str/completedBarGraph?startDate=${startDate}&endDate=${endDate}`);
};

export const fetchAgeOfCaseData = (startDate, endDate) => {
  return getDashboardData(`str/AgeOfCasesLineGraph?startDate=${startDate}&endDate=${endDate}`);
};

export const GetL2LRevenueChartData = () => {
  return getDashboardData("l2l/L2LRevenueChartWidget");
}

export const GetUserSubdepartments = () => {
  return getDashboardData("GetUserSubDepartments");
}

export const GetTechBankerTimeLog = () => {
  return getDashboardData("tech/TechBankerTimeLog");
}

export const SaveTechBankerHours = (data) => {
  return triyoAPI.post("dashboard/tech/submit-tech-banker-hours-bulk-edit", data, config());
}

export const GetEnergyBankerTimeLog = () => {
  return getDashboardData("energy/EnergyBankerTimeLog");
}

export const SaveEnergyBankerHours = (data) => {
  return triyoAPI.post("dashboard/energy/submitBankerTimeLogBulkEdit", data, config());
}

export const SearchWithinEnergyProjects = (searchValue) => {
  return getDashboardData(`energy/SearchWithinEnergyProjects?searchValue=${encodeURIComponent(searchValue)}`);
}

export const GetEnergyStafferTimeLog = () => {
  return getDashboardData("energy/EnergyStafferTimeLog");
}

export const GetEnergyBankerTimeLogForStaffer = (userId) => {
  const data = { AnalystId: userId };
  return triyoAPI.post("dashboard/energy/EnergyBankerTimeLogForStaffer", data, config());
}

export const SaveEnergyBankerHoursForStaffer = (data) => {
  return triyoAPI.post("dashboard/energy/submitBankerTimeLogBulkEditForStaffer", data, config());
}

export const GetStafferDealDetailsandResourcingLog = () => {
  return getDashboardData("energy/GetStafferDealDetailsandResourcingLog");
}

export const SaveEnergyBankerHoursStaffer = (data) => {
  return triyoAPI.post("dashboard/energy/submitStafferResourceDealLogBulkEdit", data, config());
}

export const SubmitEnergyAvailableBankers = (data) => {
  return triyoAPI.post("dashboard/energy/SubmitEnergyAvailableBankers", data, config());
}

export const GetEnergySIBankerTimeLog = () => {
  return getDashboardData("energy/EnergySIBankerTimeLog");
}

export const SaveEnergySIBankerHours = (data) => {
  return triyoAPI.post("dashboard/energy/submitSIBankerTimeLogBulkEdit", data, config());
}

export const SearchWithinSIEnergyProjects = (searchValue) => {
  return getDashboardData(`energy/SearchWithinSIEnergyProjects?searchValue=${encodeURIComponent(searchValue)}`);
}

export const GetEnergySIStafferTimeLog = () => {
  return getDashboardData("energy/EnergySIStafferTimeLog");
}

export const GetEnergySIBankerTimeLogForStaffer = (userId) => {
  const data = { AnalystId: userId };
  return triyoAPI.post("dashboard/energy/EnergySIBankerTimeLogForStaffer", data, config());
}

export const SaveEnergySIBankerHoursForStaffer = (data) => {
  return triyoAPI.post("dashboard/energy/submitSIBankerTimeLogBulkEditForStaffer", data, config());
}

export const GetSIStafferDealDetailsandResourcingLog = () => {
  return getDashboardData("energy/GetSIStafferDealDetailsandResourcingLog");
}

export const SaveSIBankerHoursStaffer = (data) => {
  return triyoAPI.post("dashboard/energy/submitSIStafferResourceDealLogBulkEdit", data, config());
}

export const GetJuniorStaffingIndex = (weeks = 8) => {
  return getDashboardData(`energy/GetJuniorStaffingIndex?weeks=${weeks}`);
}

export const GetEnergyProjectHoursByVertical = (weeks = 8) => {
  return getDashboardData(`energy/GetEnergyProjectHoursByVertical?weeks=${weeks}`);
}

export const GetPowerBankerTimeLog = () => {
  return getDashboardData("power/PowerBankerTimeLog");
}

export const SavePowerBankerHours = (data) => {
  return triyoAPI.post("dashboard/power/submitPowerBankerHoursBulkEdit", data, config());
}

export const GetPowerStafferProjectAndMemberTracker = () => {
  return getDashboardData("power/GetPowerStafferProjectAndMemberTracker");
}
export const GetPowerHistoricalData = async (filterDto) => {
  return await triyoAPI.post("data/pui/weekly-hours-report", filterDto, config());
};

export const GetLeveragedFinanceBankerTimeLog = () => {
  return getDashboardData("leveragedfinance/GetLeveragedFinanceBankerTimeLog");
}

export const GetLeveragedFinanceStafferTimeLog = () => {
  return getDashboardData("leveragedfinance/GetLeveragedFinanceStafferTimeLog");
}

export const GetLeveragedFinanceDealTracker = () => {
  return getDashboardData("leveragedfinance/GetLeveragedFinanceDealTracker");
}

export const SaveLevfinBankerDataByJuniorBanker = (data) => {
  return triyoAPI.post("dashboard/leveragedfinance/SaveLevfinBankerDataByJuniorBanker", data, config());
}

export const SaveLevfinBankerDataOnStafferDashboard = (data) => {
  return triyoAPI.post("dashboard/leveragedfinance/SaveLevfinBankerDataOnStafferDashboard", data, config());
}